<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text
        }}</v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <!-- Listado de empresas y opciones de titulo, busqueda, nuevo, etc -->
        <v-data-table :loading="loading" :headers="headers" :items="empresas" :search="buscar" class="elevation-3"
          dense>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>EMPRESA</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <!-- Impresion empresa -->
              <v-btn text fab x-small color="accent" @click="crearPDF()" class="mr-1" v-if="esSuperadministrador">
                <v-icon>description</v-icon>
              </v-btn>
              <!-- Fin impresion empresa -->
              <v-spacer />
              <!-- Formulario busqueda de empresa -->
              <v-text-field v-if="esSuperadministrador" class="text-xs-center" v-model.trim="buscar"
                append-icon="search" v-uppercase dense label="Búsqueda" single-line hide-details></v-text-field>
              <!-- Fin Formulario Busqueda de empresa -->
              <v-spacer />
              <!-- Modal crear y modificar empresa -->
              <v-dialog v-model="dialog" max-width="600px" persistent>
                <template v-slot:activator="{ on }" v-if="esSuperadministrador">
                  <v-btn class="ma-2" fab x-small dark color="primary" v-on="on">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar dark dense class="primary">
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon dark @click="guardar" :loading="desabilitar" :disabled="desabilitar || !isValid">
                      <v-icon>save</v-icon>
                    </v-btn>
                    <v-btn icon dark @click="close">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="12" align="center">
                          <template v-if="file">
                            <v-avatar tile size="80">
                              <v-img :src="urlTemporal" @click="$refs.boton.click()" />
                            </v-avatar>
                          </template>
                          <template v-else-if="logo == ''">
                            <v-avatar tile size="80px">
                              <img :src="'data:image/png;base64,' + logoxdefec" @click="$refs.boton.click()" />
                            </v-avatar>
                          </template>
                          <template v-else>
                            <v-avatar tile size="80">
                              <img :src="'data:image/png;base64,' + logo" @click="$refs.boton.click()" />
                            </v-avatar>
                          </template>
                          <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                            @change="buscarImagen($event)" class="d-none" />
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field dense v-model.trim="nombre" label="Razón social" maxlength="80"
                            prepend-inner-icon="business"
                            :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 3 && v.length <= 80) || 'Nombre debe tener entre 3 a 80 caracteres', Rules.unespacio]"
                            v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="10">
                          <v-text-field dense v-model.trim="detalle_inv" label="Detalle Inventario" maxlength="25"
                            prepend-inner-icon="business"
                            :rules="[v => !!v || 'Detalle requerido', v => (!!v && v.length >= 6 && v.length <= 25) || 'Nombre debe tener entre 6 a 25 caracteres', Rules.unespacio]"
                            v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="2">
                          <v-text-field dense v-model.trim="ano_inv" label="Año Inv." maxlength="4"
                            :rules="[v => !!v || 'Requerido', v => (!!v && v.length > 3 && v.length <= 4) || 'Año debe tener 4 caracteres', Rules.unespacio]"
                            v-mask-number hide-details></v-text-field>
                        </v-col>
                        <v-col cols="8" sm="6">
                          <v-text-field dense v-model.trim="ruc" label="Ruc" maxlength="11"
                            prepend-inner-icon="featured_play_list"
                            :rules="[v => !!v || 'Ruc requerido', v => (!!v && v.length == 11) || 'Ruc debe tener 11 caracteres']"
                            v-mask-number hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field dense v-model.trim="direccion" label="Dirección"
                            :rules="[v => !!v || 'Dirección requerido', v => v.length <= 100 || 'La dirección no debe tener mas de 60 caracteres', Rules.unespacio]"
                            maxlength="60" prepend-inner-icon="location_on" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field dense v-model.trim="telefono" label="Telefono"
                            :rules="[v => !!v || 'Telefono requerido', Rules.unespacio]" maxlength="20"
                            prepend-inner-icon="phone" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5">
                          <v-text-field dense v-model.trim="email" label="Email"
                            :rules="[v => /.+@.+\..+/.test(v) || 'El email debe ser válido', Rules.sinespacio]"
                            maxlength="50" prepend-inner-icon="mail" v-lowercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <v-select dense :items="selectTipos" v-model="tipo" label="Tipo empresa"
                            :rules="[v => !!v || 'Requerido']" :disabled="!esSuperadministrador" required
                            hide-details></v-select>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-menu v-model="menuFechaRegistro" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field dense v-model="fecha_registro_formateado" label="Fecha registro"
                                :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on" prepend-inner-icon="event"
                                :disabled="!esSuperadministrador" hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="fecha_registro" @input="menuFechaRegistro = false"
                              @change="fechaRegistroSeleccionada(fecha_registro)"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-menu v-model="menuFechaInicio" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field dense v-model="fecha_inicio_formateado" label="Fecha inicio Lic."
                                :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on" prepend-inner-icon="event"
                                :disabled="!esSuperadministrador" hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="fecha_inicio" @input="menuFechaInicio = false"
                              @change="fechaInicioSeleccionada(fecha_inicio)"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-menu v-model="menuFechaFin" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field dense v-model="fecha_fin_formateado" label="Fecha fin Lic."
                                :rules="[v => !!v || 'Fecha Requerido']" readonly v-on="on" prepend-inner-icon="event"
                                :disabled="!esSuperadministrador" hide-details></v-text-field>
                            </template>
                            <v-date-picker v-model="fecha_fin" @input="menuFechaFin = false"
                              @change="fechaFinSeleccionada(fecha_fin)"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <template v-if="esSuperadministrador">
                          <v-col cols="12" sm="4">
                            <v-select dense v-model="idplan" :items="planes" label="Plan"
                              :rules="[v => !!v || 'El plan es requerido']" hide-details></v-select>
                          </v-col>
                          <v-col cols="8">
                            <v-textarea dense rows="1" v-model.trim="observacion" label="Observación" maxlength="1000"
                              v-uppercase hide-details></v-textarea>
                          </v-col>
                        </template>
                        <v-col cols="12">
                          <v-expansion-panels>
                            <v-expansion-panel>
                              <v-expansion-panel-header>Color Aplicación</v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <div class="d-flex justify-center align-center">
                                  <v-color-picker v-model="color_app" hide-mode-switch></v-color-picker>
                                </div>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-col>
                        <!-- Mensaje error empresa -->
                        <v-col cols="12" v-if="mensajeEmpresa != ''">
                          <v-alert text dense type="error">{{ mensajeEmpresa }}</v-alert>
                        </v-col>
                        <!-- Mensaje error empresa -->
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <!-- Fin Modal crear y modificar empresa -->

              <!-- Modal activar, desactivar empresa -->
              <v-dialog v-model="adModal" max-width="300">
                <v-card>
                  <v-card-title class="headline justify-center" v-if="adAccion == 1">¿Activar Empresa?</v-card-title>
                  <v-card-title class="headline justify-center" v-if="adAccion == 2">¿Desactivar Empresa?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccion == 1">Activar</span>
                    <span v-if="adAccion == 2">Desactivar</span>
                    la Empresa {{ adNombre }}
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn text x-small color="error" @click="activarDesactivarCerrar">Cancelar</v-btn>
                    <v-btn v-if="adAccion == 1" text x-small color="success" @click="activar">Activar</v-btn>
                    <v-btn v-if="adAccion == 2" text x-small color="warning" @click="desactivar">Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar, desactivar empresa -->

              <!-- Modal activar, desactivar seguimiento_inv -->
              <v-dialog v-model="adModalSeg" max-width="440">
                <v-card>
                  <v-card-title class="headline justify-center" v-if="adAccionSeg == 1">¿Activar Seguimiento
                    Inventario?</v-card-title>
                  <v-card-title class="headline justify-center" v-if="adAccionSeg == 2">¿Desactivar Seguimiento
                    Inventario?</v-card-title>
                  <v-card-text>
                    Estás a punto de
                    <span v-if="adAccionSeg == 1">Activar</span>
                    <span v-if="adAccionSeg == 2">Desactivar</span>
                    el seguimiento de inventario a la empresa {{ adNombreSeg }}, todo el seguimiento de los bienes
                    patrimoniales de reiniciaran.
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 justify-center">
                    <v-btn text x-small color="error" @click="activarDesactivarCerrarSeg">Cancelar</v-btn>
                    <v-btn v-if="adAccionSeg == 1" text x-small color="success" @click="activarSeg">Activar</v-btn>
                    <v-btn v-if="adAccionSeg == 2" text x-small color="warning"
                      @click="desactivarSeg">Desactivar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modal activar, desactivar seguimiento_inv -->
            </v-toolbar>
          </template>
          <!-- Opciones editar, eliminar empresa -->
          <template v-slot:item.logo="{ item }">
            <template>
              <v-avatar tile size="36">
                <img :src="'data:image/png;base64,' + item.logo" />
              </v-avatar>
            </template>
          </template>
          <template v-slot:item.fecha_registro="{ item }">
            <span>{{ item.fecha_registro | formatearFecha }}</span>
          </template>

          <template v-slot:item.condicion="{ item }">
            <template v-if="item.condicion">
              <v-btn text x-small color="success" @click="activarDesactivarMostrar(2, item)">Activo</v-btn>
            </template>
            <template v-else>
              <v-btn text x-small color="warning" @click="activarDesactivarMostrar(1, item)">Inactivo</v-btn>
            </template>
          </template>

          <template v-slot:item.seguimiento="{ item }">
            <template v-if="item.seguimiento_inv == 'SI'">
              <v-btn text x-small color="success" @click="activarDesactivarMostrarSeg(2, item)">SI</v-btn>
            </template>
            <template v-else>
              <v-btn text x-small color="warning" @click="activarDesactivarMostrarSeg(1, item)">NO</v-btn>
            </template>
          </template>

          <template v-slot:item.opciones="{ item }">
            <v-btn x-small icon>
              <v-icon color="info" @click="editItem(item)">edit</v-icon>
            </v-btn>
            <v-btn x-small icon>
              <v-icon color="error" @click="deleteItem(item)">delete_forever</v-icon>
            </v-btn>
          </template>
          <!-- Fin Opciones editar, eliminar empresa -->
        </v-data-table>
        <!-- Fin Listado de empresas y opciones de titulo, busqueda, nuevo, etc -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState, mapGetters, mapActions, } from "vuex"; //Importamos para llamar a los elementos empresa

export default {
  data() {
    return {
      empresas: [],
      dialog: false,
      headers: [
        { text: "Logo", value: "logo", sortable: false },
        { text: "Empresa", value: "nombre", sortable: false },
        { text: "RUC", value: "ruc", sortable: false },
        { text: "Dirección", value: "direccion", sortable: false },
        { text: "Fec.Reg.", value: "fecha_registro", sortable: false },
        { text: "Seg./Inv.", align: "center", value: "seguimiento", sortable: false },
        { text: "Condición", align: "center", value: "condicion", sortable: false },
        { text: "Opción", value: "opciones", sortable: false },
      ],
      buscar: "",
      editedIndex: -1,

      idempresa: "",
      planes: [],
      idplan: "",
      nombre: "",
      ruc: "",
      direccion: "",
      telefono: "",
      email: "",
      logo: "",
      tipo: "", // selectTipos
      detalle_inv: "",
      ano_inv: "",
      fecha_registro: "",
      fecha_inicio: "",
      fecha_fin: "",
      observacion: "",
      color_app: "#1B5DB2",

      file: null,
      urlTemporal: "",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",

      adModalSeg: 0,
      adAccionSeg: 0,
      adNombreSeg: "",
      adIdSeg: "",

      mensajeEmpresa: "",

      buscar_empresa: "",

      desabilitar: false,
      isValid: true,
      alerta: { snackbar: false, color: "", text: "" },

      fecha_registro_formateado: "",
      menuFechaRegistro: false,
      fecha_inicio_formateado: "",
      menuFechaInicio: false,
      fecha_fin_formateado: "",
      menuFechaFin: false,

      selectTipos: [{ text: "PRIVADO" }, { text: "ESTATAL" }],

      logoxdefec:
        "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",

      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {
    ...mapGetters(["esSuperadministrador"]),
    ...mapState(["empresaState", "usuarioState"]), // Llamamos a state para empresas y usuarios

    formTitle() {
      return this.editedIndex === -1 ? "Nueva empresa" : "Actualizar empresa";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.selectPlan();
  },

  methods: {
    ...mapActions(["autoLogin"]),

    /* Listar empresas */
    listar() {
      let me = this;
      me.loading = true;

      let url = "";
      if (me.esSuperadministrador) {
        url =
          "api/Empresas/ListarEmpresaFiltro?buscar=" +
          (me.buscar_empresa == "" ? "-" : me.buscar_empresa);
      } else {
        url = "api/Empresas/ListarEmpresa/" + me.usuarioState.idempresa;
      }

      axios
        .get(url)
        .then(function (response) {
          me.empresas = response.data;
          me.loading = false;
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
    /* Fin Listar empresas */

    selectPlan() {
      let me = this;

      var planesArray = [];
      axios
        .get("api/Planes/Select")
        .then(function (response) {
          planesArray = response.data;
          planesArray.map(function (x) {
            me.planes.push({
              text:
                x.planes +
                " - Nº " +
                x.nro_bienes +
                " - S/ " +
                x.importe.toFixed(2),
              value: x.idplan,
            });
          });
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    /* Editar y guardar empresa */
    guardar() {
      let me = this;
      me.desabilitar = true;

      if (me.editedIndex > -1) {
        //Código para editar
        axios
          .put("api/empresas/Actualizar", {
            idempresa: me.idempresa,
            idplan: me.idplan,
            nombre: me.nombre,
            ruc: me.ruc,
            direccion: me.direccion,
            telefono: me.telefono,
            email: me.email,
            logo: me.logo == "" ? me.logoxdefec : me.logo,
            tipo: me.tipo,
            detalle_inv: me.detalle_inv,
            ano_inv: me.ano_inv,
            fecha_registro: me.fecha_registro,
            fecha_inicio: me.fecha_inicio,
            fecha_fin: me.fecha_fin,
            observacion: me.observacion,
            color_app: me.color_app,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
            me.autoLogin();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeEmpresa = error.response.data;
            //me.mensajeEmpresa = error.response.data.errors.nombre[0];
            me.limpiarAlertaError();
          });
      } else {
        //Código para guardar
        axios
          .post("api/empresas/Crear", {
            idplan: me.idplan,
            nombre: me.nombre,
            ruc: me.ruc,
            direccion: me.direccion,
            telefono: me.telefono,
            email: me.email,
            logo: me.logo == "" ? me.logoxdefec : me.logo,
            tipo: me.tipo,
            detalle_inv: me.detalle_inv,
            ano_inv: me.ano_inv,
            fecha_registro: me.fecha_registro,
            fecha_inicio: me.fecha_inicio,
            fecha_fin: me.fecha_fin,
            observacion: me.observacion,
            color_app: me.color_app,
          })
          .then(function (response) {
            me.desabilitar = false;
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            me.close();
            me.listar();
            me.limpiar();
          })
          .catch(function (error) {
            me.desabilitar = false;
            me.mensajeEmpresa = error.response.data;
            me.limpiarAlertaError();
          });
      }
    },
    /* Fin Editar y guardar empresa */

    /* Opciones fecha_registro seleccionada movimiento */
    fechaRegistroSeleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_registro_formateado = ddmmyy;
    },
    fechaInicioSeleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_inicio_formateado = ddmmyy;
    },
    fechaFinSeleccionada(dia) {
      let arrayFecha = dia.split(["-"]);
      let ddmmyy = arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
      this.fecha_fin_formateado = ddmmyy;
    },
    /* Fin Opciones fecha_registro seleccionada movimiento */

    /* Eliminar empresa */
    deleteItem(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar la empresa " + item.nombre + "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete("api/empresas/Eliminar/" + item.idempresa)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },
    /* Fin Eliminar empresa */

    /* Limpiar mensaje empresa */
    limpiarAlertaError() {
      setTimeout(() => {
        this.mensajeEmpresa = "";
      }, 3000);
    },
    /* Fin Limpiar mensaje empresa */

    /* Editar empresa item */
    editItem(item) {
      this.idempresa = item.idempresa;
      this.idplan = item.idplan;
      this.nombre = item.nombre;
      this.ruc = item.ruc;
      this.direccion = item.direccion;
      this.telefono = item.telefono;
      this.email = item.email;
      this.logo = item.logo;
      this.tipo = item.tipo;
      this.detalle_inv = item.detalle_inv;
      this.ano_inv = item.ano_inv;
      this.fecha_registro = item.fecha_registro;
      this.fechaRegistroSeleccionada(item.fecha_registro);
      this.fecha_inicio = item.fecha_inicio;
      this.fechaInicioSeleccionada(item.fecha_inicio);
      this.fecha_inicio = item.fecha_inicio;
      this.fechaFinSeleccionada(item.fecha_fin);
      this.fecha_fin = item.fecha_fin;
      this.observacion = item.observacion;
      this.color_app = item.color_app;
      this.editedIndex = 1;
      this.dialog = true;
    },
    /* Fin Editar empresa item */

    /* Cerrar ventana empresa */
    close() {
      this.dialog = false;
      this.limpiar();
    },
    /* Fin Cerrar ventana empresa */

    /* Limpiar empresa item */
    limpiar() {
      this.idempresa = "";
      this.idplan = "";
      this.nombre = "";
      this.ruc = "";
      this.direccion = "";
      this.telefono = "";
      this.email = "";
      this.logo = "";
      this.tipo = "";
      this.detalle_inv = "";
      this.ano_inv = "";
      this.fecha_registro = "";
      this.fecha_registro_formateado = "";
      this.fecha_inicio = "";
      this.fecha_inicio_formateado = "";
      this.fecha_fin = "";
      this.fecha_fin_formateado = "";
      this.observacion = "";
      this.color_app = "";
      this.file = null;
      this.urlTemporal = "";
      this.mensajeEmpresa = "";
      // Limpiamos input carga de imagen
      document.getElementById("file").value = [];
      this.editedIndex = -1;
    },
    /* Fin Limpiar empresa item */

    /* Buscar imagen empresa */
    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64 al usuario despues de cargar imagen
        };

        // Reducimos imagen con un ancho de 200px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            return dataUrl;
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 200,
        })
          .then((resizedImage) => {
            this.logo = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
    /* Fin Buscar imagen empresa */

    /* Desactivar, activar empresa */
    desactivar() {
      let me = this;

      axios
        .put("api/Empresas/Desactivar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.nombre;
      this.adId = item.idempresa;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar() {
      let me = this;
      axios
        .put("api/Empresas/Activar/" + this.adId, {})
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar empresa */

    /* Desactivar, activar seguimiento_inv */
    desactivarSeg() {
      let me = this;

      axios
        .put("api/Empresas/DesactivarSeg/" + this.adIdSeg, {})
        .then(function (response) {
          me.adModalSeg = 0;
          me.adAccionSeg = 0;
          me.adNombreSeg = "";
          me.adIdSeg = "";
          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    activarDesactivarMostrarSeg(accion, item) {
      this.adModalSeg = 1;
      this.adNombreSeg = item.nombre;
      this.adIdSeg = item.idempresa;
      if (accion == 1) {
        this.adAccionSeg = 1;
      } else if (accion == 2) {
        this.adAccionSeg = 2;
      } else {
        this.adModalSeg = 0;
      }
    },

    activarDesactivarCerrarSeg() {
      this.adModalSeg = 0;
    },

    activarSeg() {
      let me = this;
      axios
        .put("api/Empresas/ActivarSeg/" + this.adIdSeg, {})
        .then(function (response) {
          me.adModalSeg = 0;
          me.adAccionSeg = 0;
          me.adNombreSeg = "";
          me.adIdSeg = "";

          me.alerta.snackbar = true;
          me.alerta.color = "success";
          me.alerta.text = response.data;

          me.listar();
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    /* Fin Desactivar, activar seguimiento_inv */

    /* Eliminar empresa */
    deleteItem(item) {
      const respta = confirm(
        "¿Estás seguro de que deseas eliminar la empresa " + item.nombre + "?"
      );
      if (respta) {
        let me = this;
        axios
          .delete("api/Empresas/Eliminar/" + item.idempresa)
          .then((response) => {
            me.alerta.snackbar = true;
            me.alerta.color = "success";
            me.alerta.text = response.data;
            this.listar();
          })
          .catch(function (error) {
            me.alerta.snackbar = true;
            me.alerta.color = "error";
            me.alerta.text = error.response.data;
          });
      }
    },
    /* Fin Eliminar empresa */

    /* Crear PDF empresa */
    crearPDF() {
      var columns = [
        { header: "NOMBRE", dataKey: "nombre" },
        { header: "RUC", dataKey: "ruc" },
        { header: "CONDICION", dataKey: "condicion" },
      ];
      var body = [];

      this.empresas.map(function (x) {
        body.push({
          nombre: x.nombre,
          ruc: x.ruc,
          condicion: x.condicion == 1 ? "Activo" : "Inactivo",
        });
      });
      //console.log(body);
      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text("LISTADO DE EMPRESAS", doc.internal.pageSize.width / 2, 45, {
            align: "center",
          });
        }
      };
      // Agregar pie de pagina: numeración
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "italic");
        doc.setFontSize(7);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.text(
            "Pagina " + String(i) + " de " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
        }
      };

      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var doc = new jsPDF("p", "pt");

      doc.addImage(imgData, "JPEG", 40, 17, 35, 40);
      doc.autoTable({
        columns,
        body,
        margin: { top: 70 },
        styles: { overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          fillColor: [46, 78, 121],
          fontSize: 7,
          halign: "center",
        },
        bodyStyles: { textColor: 0, fontSize: 8 },
        columnStyles: {
          nombre: { cellWidth: "150" },
          ruc: { cellWidth: "250" },
          condicion: { cellWidth: "115", halign: "center" },
        },
      });
      // 515 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      doc.save("Empresa.pdf");
    },
    /* Fin Crear PDF empresa */
  },
};
</script>
